import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Field, withFormik } from "formik";
import isEmpty from "lodash/isEmpty";

import i18n from "../../../../translations/i18n";
import {
  APPOINTMENT_PURPOSE_SHAPE,
  APPOINTMENT_PURPOSE_OPTIONS,
} from "../../../../constants/appointmentConstants";

import FormActions from "../../../../components/ui/form/actions";
import FormError from "../../../../components/ui/form/error";
import CheckboxGroupField from "../../../../components/ui/form/checkbox_group";
import Button from "../../../../components/ui/form/button";
import {
  TrackFieldError,
  TrackFieldValid,
  TrackAddAppointmentSubmitClick,
  TrackAddAppointmentSubmitError,
} from "../../../../helpers/analytics";
import FormGroup from "../../../ui/form/group";
import InputField from "../../../ui/form/input_field";
import MaskInputField from "../../../ui/form/mask_input_field";
import phoneIsLandline from "../../../../helpers/landlinePhoneCodes";
import emailDomainIsInvalid from "../../../../helpers/invalidEmailDomains";

class AppointmentForm extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { serverError, errors, isSubmitting, handleSubmit, touched } = this.props;

    return (
      <Form>
        <div className="modal__title">
          {i18n.t('modal.appointment.form.purpose.title')}
        </div>
        <p>
          {i18n.t('modal.appointment.form.purpose.message')}
        </p>
        <p>
          {i18n.t("modal.appointment.form.purpose.label")}
        </p>
        <Field
          name="purpose"
          component={CheckboxGroupField}
          options={APPOINTMENT_PURPOSE_OPTIONS}
          disabled={isSubmitting}
        />
        <p className="modal__small-text">
          {i18n.t("modal.appointment.form.notice.text")}
        </p>
        <p className="modal__small-text">
          {i18n.t("modal.appointment.form.contacts.text")}
        </p>
        <div className="p-partners__form-section">
          <div className="section-title p-partners__form-section-title">
            {i18n.t("pages.about.order.user.title")}
          </div>

          <div className="p-about__order-field-wrapper" key="username">
            <FormGroup
              className="form__group"
              label={i18n.t('pages.partners.form.username.label')}
              touched={touched.username}>
              <Field
                component={InputField}
                className="form__field p-about__order-field"
                name="username"
                required
              />
            </FormGroup>
          </div>

          <div className="p-about__order-field-wrapper" key="phone">
            <FormGroup
              className="form__group"
              label={i18n.t('pages.about.order.select.phone')}
              touched={touched.phone}>
              <Field
                component={MaskInputField}
                className="form__field p-about__order-field"
                mask="+7 (999) 999-99-99"
                name="phone"
              />
            </FormGroup>
          </div>

          <div className="p-about__order-field-wrapper" key="email">
            <FormGroup
              className="form__group"
              label={i18n.t('pages.about.order.select.email')}
              touched={touched.email}>
              <Field
                component={InputField}
                className="form__field p-about__order-field"
                name="email"
                required
              />
            </FormGroup>
          </div>
        </div>
        <FormActions className="modal__form-button-wrapper">
          <FormError>
            {serverError}
          </FormError>
          <FormError>
            {errors.purpose}
          </FormError>
          <div className="p-partners__form-checkbox checkbox modal__small-text">
            <input id="agreement" type="checkbox" name="agreement" required />
            <label htmlFor="agreement">
              {i18n.t("pages.partners.form.agreement_text")}
            </label>
            <a href="/privacy" target="_blank" rel="noopener noreferrer"><u>{i18n.t("pages.partners.form.privacy_policy")}</u></a>
          </div>
          <Button
            className="modal__form-button"
            type="submit"
            disabled={isSubmitting}
            onSubmit={handleSubmit}
          >
            {i18n.t("modal.appointment.form.submit.title")}
          </Button>
        </FormActions>
      </Form>
    )
  }
}

const AppointmentFormWithFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({initialValues}) => initialValues,
  handleSubmit: (values, {props: {onSubmit}}) => onSubmit(values),
  validate: (values) => {
    let errors = {};

    TrackAddAppointmentSubmitClick(values.source, values.paintingName)

    const requiredUserFields = ['username', 'email']

    requiredUserFields.map((field) => {
      if (isEmpty(values[field])) {
        TrackFieldError(field, 'empty', values.source);
        errors[field] = i18n.t("validation.field.required");
      } else {
        TrackFieldValid(field, values.source);
      }
    });

    if (!isEmpty(values.phone) && (!/^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/i.test(values.phone))) {
      TrackFieldError('phone', 'empty', values.source);
      errors.phone = i18n.t("validation.phone.invalid");
    } else if (!isEmpty(values.phone) && phoneIsLandline(values.phone)) {
      TrackFieldError('phone', 'invalid', values.source);
      errors.phone = i18n.t("validation.phone.landline");
    } else {
      TrackFieldValid('phone', values.source);
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
      TrackFieldError('email', 'empty', values.source);
      errors.email = i18n.t("validation.email.invalid");
    } else if (emailDomainIsInvalid(values.email)) {
      TrackFieldError('email', 'invalid', values.source);
      errors.email = i18n.t("validation.email.invalid");
    } else {
      TrackFieldValid('email', values.source);
    }

    if (isEmpty(values.purpose)) {
      TrackFieldError('purpose', 'empty', values.source);
      errors.purpose = i18n.t("modal.appointment.form.validation.purpose.required");
    } else {
      TrackFieldValid('purpose', values.source)
    }

    if (!isEmpty(errors)) {
      TrackAddAppointmentSubmitError();
    }

    return errors;
  },
})(AppointmentForm);

AppointmentFormWithFormik.propTypes = {
  initialValues: PropTypes.shape(APPOINTMENT_PURPOSE_SHAPE).isRequired,
  serverError: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

export default AppointmentFormWithFormik
